import gql from 'graphql-tag';

export default gql`
  query SearchSugestionQuery($searchTerm: String!) {
    viewer {
      searchSuggestions(query: $searchTerm) {
        total
        sections {
          name
          link
          total
          suggestions {
            title
            subtitle
            thumbnail
            url
            trackingInfo {
              consumer
              position
              service
              trackingToken
            }
          }
        }
      }
    }
  }
`;
